import classNames from "classnames";
import { FC, ReactNode } from "react";

type Props = {
  disabled?: boolean;
  disableassign?: boolean;
  type: "button" | "submit" | "reset";
  dataCy?: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  delay?: boolean;
  disableCount?: boolean;
  isSubmitting?: boolean;
  isLoading?: boolean;
};

const Button: FC<Props> = ({
  onClick,
  type,
  dataCy,
  className,
  children,
  disabled,
  disableassign,
  delay,
  disableCount,
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      data-cy={dataCy}
      {...rest}
      disabled={disableassign || disabled}
      className={classNames(
        `flex justify-center items-center rounded-md border border-transparent py-3 px-4 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-outline focus:ring-offset-2 transition-all duration-200 ${className}`,
        {
          "bg-primary md:hover:bg-primary-200": !(
            delay ||
            disableassign ||
            disableCount ||
            disabled
          ),
          "bg-neutral-500 hover:bg-neutral-700":
            delay || disableassign || disableCount || disabled,
        },
      )}
    >
      {children}
    </button>
  );
};

export { Button };
